/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentSignatureType {
    ELECTRONIC = 'ELECTRONIC',
    WET_INK = 'WET_INK',
    REVIEW = 'REVIEW',
    SUBMITTABLE = 'SUBMITTABLE',
}
